<template>
  <div>
    <div class="md-title">{{flight.name}}</div>
    <md-switch v-model="showDiagram">
      <div class="sub-header">{{`${flightMatches.length} matches`}}</div>
    </md-switch>
    <p></p>
    <!-- A tree presentation of matches -->
    <table class="flight" v-if="showDiagram">
      <tr v-for="row in rowOfMatches">
        <td
          v-for="match in row"
          :key="match.id"
          :class="match === MATCH_EMPTY ? 'empty' : match === MATCH_CONNECTOR ? 'match-connector': 'match'"
        >
          <Match v-if="match.id" :match="match" :tournament="tournament"/>
        </td>
      </tr>
    </table>
    <div v-if="flight.rounds.length < 2 && flight.standings && flight.standings.length > 0">
      <p></p>
      <md-table v-model="flight.standings" md-card>
        <md-table-toolbar>
          <h3>{{flight.name}} Standings</h3>
        </md-table-toolbar>

        <md-table-head md-numeric>#</md-table-head>
        <md-table-head>Name</md-table-head>
        <md-table-head>Results</md-table-head>
        <md-table-head md-numeric>Points</md-table-head>

        <md-table-row v-for="(item, index) in flight.standings" :key="item.id">
          <md-table-cell md-numeric>{{ index + 1 }}</md-table-cell>
          <md-table-cell>{{ item.name }}</md-table-cell>
          <md-table-cell>{{ item.resultSequence && item.resultSequence.join("·") }}</md-table-cell>
          <md-table-cell md-numeric>{{ item.points }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>

<script>
import { relativeTime, MatchTools } from "@/js/helper";
import Match from "./match.vue";

function getMatchSequence(winnerDestinationMatchId, nextRoundMatches) {
  if (winnerDestinationMatchId && nextRoundMatches)
    return nextRoundMatches.findIndex(x => x.id === winnerDestinationMatchId);
  return -1;
}

const MATCH_EMPTY = "_";
const MATCH_CONNECTOR = "MC";

export default {
  name: "FlightList",
  props: { flight: Object, tournament: Object },
  components: { Match },
  data: function() {
    return {
      MATCH_EMPTY: MATCH_EMPTY,
      MATCH_CONNECTOR: MATCH_CONNECTOR,
      showDiagram: true
    };
  },
  computed: {
    flightMatches: {
      get() {
        return this.tournament.matches.filter(
          x => x.flightId === this.flight.id
        );
      }
    },
    rowOfMatches: {
      get() {
        const n = this.flight.rounds.length;

        // Group matches into rounds and order them by winning-destination matches
        let result = [];
        const roundMatches = [];
        let nextRoundMatches = undefined;
        for (let i = 0; i < n; i++) {
          const r = n - i - 1; // go backwards from last round to first in order determine order of matches
          const currentRound = this.flight.rounds[r];
          const currentRoundMatches = this.flightMatches
            .filter(x => x.roundId === currentRound.id)
            .sort((a, b) => {
              const ai = getMatchSequence(
                a.winnerDestinationMatchId,
                nextRoundMatches
              );
              const bi = getMatchSequence(
                b.winnerDestinationMatchId,
                nextRoundMatches
              );
              return (ai < bi && -1) || ((bi < ai && 1) || 0);
            });
          nextRoundMatches = roundMatches[r] = currentRoundMatches;
        }

        // Construct the rows for the match tables
        if (n > 1) {
          // Display as tree
          const nrows = Math.floor(Math.pow(2, n - 1) * 2);
          result = new Array(nrows);
          for (let i = 0; i < nrows; i++) result[i] = [];

          // Go through each round add the match cells and empty cells and connector cells
          for (let r = 0; r < n; r++) {
            const round = roundMatches[r];
            let skip = Math.floor(Math.pow(2, r)) - 1;
            let i = 0;

            // Insert leading empty cells
            for (let j = 0; j < skip; j++) {
              result[j].push(MATCH_EMPTY);
              i++;
            }

            const nmatches = round.length;
            skip = Math.floor(nrows / nmatches) - 1;
            for (let j = 0; j < nmatches; j++) {
              const match = round[j];
              result[i].push(match);
              i++;

              // Insert empty cells
              const nEmpty = Math.min(skip, nrows - i);
              for (let z = 0; z < nEmpty; z++) {
                if (j % 2 == 0 && j < nmatches - 1)
                  result[i].push(MATCH_CONNECTOR);
                else result[i].push(MATCH_EMPTY);
                i += 1;
              }
            }
            // Insert trailing empty cells
            for (let j = i; j < nrows; j++) result[i].push(MATCH_EMPTY);
          }
        } else if (n > 0) {
          // Display as list
          // Construct the round robin table
          const round = roundMatches[0];
          const nmatches = round.length;
          const ncomp = Math.ceil(Math.sqrt(1 + 8 * nmatches) / 2);
          result = new Array(ncomp);
          for (let i = 0; i < ncomp; i++) result[i] = [];

          // Insert empty cells
          let curRow = 0;
          let accum = ncomp - 1;

          // Insert match cells
          for (let j = 0; j < nmatches; j++) {
            if (j >= accum) {
              curRow++;
              accum += ncomp - curRow - 1;
            }

            const match = round[j];
            result[curRow].push(match);
          }
        }

        return result;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.flight {
  border-collapse: collapse;
}

.match {
  margin: 0;
}
.match-connector {
  @extend .match;
  border-right: solid;
  padding: 0;
}
.empty {
  margin: 0;
  padding: 0;
}

.pool.td {
  width: 75%;
  padding-right: 5em;
}
.standings.td {
  vertical-align: text-top;
}
</style>


// WEBPACK FOOTER //
// flightDiagram.vue?5e24d045